import React from "react";
import "./Legal.css";

function Privacy() {
  return (
    <div className="legal-container">

      <h1>Privacy Policy</h1>
      <p className="date">Last Updated: March 2026</p>

      <p>
        At <b>TheBlogsSphere</b>,
        we respect your privacy.
      </p>

      <h2>1. Information We Collect</h2>

      <ul>
        <li>Name</li>
        <li>Email</li>
        <li>Account data</li>
        <li>Content you post</li>
        <li>Technical data (IP, browser, device)</li>
      </ul>

      <h2>2. How We Use Data</h2>

      <ul>
        <li>Account login</li>
        <li>Security</li>
        <li>Improve service</li>
        <li>Show ads</li>
      </ul>

      <h2>3. Ads & Third-Party Services</h2>

      <p>
        We use ad networks like Monetag.
        These may collect cookies,
        device info, or usage data.
      </p>

      <p>
        We do not control third-party ads.
      </p>

      <h2>4. Data Security</h2>

      <p>
        We try to protect data,
        but no system is 100% secure.
      </p>

      <h2>5. Data Sharing</h2>

      <p>
        We do not sell user data.
        Data may be shared only for
        service operation.
      </p>

      <h2>6. Cookies</h2>

      <p>
        Cookies may be used
        for login and ads.
      </p>

      <h2>7. Updates</h2>

      <p>
        Policy may change anytime.
      </p>

      <h2>8. User Responsibility</h2>

      <p>
        Users must keep account safe.
        Do not share password.
      </p>


      {/* ✅ NEW STRONG PRIVACY CLAUSES */}

      <h2>9. Legal Basis for Processing</h2>

      <p>
        We process your personal data based on your consent when you
        create an account, the necessity to perform our services to you,
        our legitimate interest in operating and improving the platform,
        and compliance with applicable legal obligations.
      </p>

      <h2>10. Data Retention</h2>

      <p>
        We retain your personal data only for as long as necessary to
        provide our services, comply with legal obligations, resolve
        disputes, and enforce our agreements. If you delete your account,
        we may retain certain data for a limited period for legal,
        security, or fraud-prevention purposes, after which it will be
        deleted or anonymized.
      </p>

      <h2>11. Your Rights</h2>

      <p>
        Subject to applicable law, you have the right to:
      </p>

      <ul>
        <li>Access the personal data we hold about you</li>
        <li>Request correction of inaccurate or incomplete data</li>
        <li>Request deletion of your account and associated data</li>
        <li>Withdraw consent for data processing where consent is the basis</li>
        <li>Object to or restrict certain processing of your data</li>
      </ul>

      <p>
        To exercise these rights, contact us through the official contact
        details provided on this platform. We may take reasonable time to
        verify your identity before acting on such requests.
      </p>

      <h2>12. Children's Privacy</h2>

      <p>
        This platform is not intended for children under the age of 13.
        We do not knowingly collect personal data from children under 13.
        If we become aware that a child under 13 has provided us with
        personal data, we will take steps to delete such information
        promptly.
      </p>

      <h2>13. Data Breach Notification</h2>

      <p>
        In the event of a data breach that poses a significant risk to
        your rights and personal data, we will make reasonable efforts to
        notify affected users and relevant authorities as required by
        applicable law, without undue delay.
      </p>

      <h2>14. International Data Transfer</h2>

      <p>
        Your data may be stored, processed, or transferred on servers
        located outside your country of residence, including through
        third-party service providers (such as hosting, database, and
        media storage providers). By using this platform, you consent to
        such transfer, storage, and processing.
      </p>

      <h2>15. Third-Party Service Providers</h2>

      <p>
        We use trusted third-party services to operate this platform,
        including but not limited to hosting providers, database
        providers, media storage providers, authentication services, and
        ad networks. These providers may process limited data strictly
        necessary to perform their function and are expected to maintain
        appropriate data protection standards.
      </p>

      <h2>16. Do Not Track Signals</h2>

      <p>
        Our platform does not currently respond to "Do Not Track" browser
        signals. Third-party ad networks integrated into our platform may
        still collect data as described in their own privacy policies.
      </p>

      <h2>17. Marketing Communications</h2>

      <p>
        We may send you service-related notifications, updates, or
        promotional communications. You may opt out of promotional
        communications at any time by following the unsubscribe
        instructions provided or by contacting us directly. You may
        continue to receive essential service-related communications even
        after opting out of marketing messages.
      </p>

      <h2>18. Account Deletion</h2>

      <p>
        You may request deletion of your account at any time. Upon
        deletion, your profile and associated personal data will be
        removed from active systems within a reasonable timeframe, except
        where retention is required for legal, security, fraud-prevention,
        or dispute-resolution purposes.
      </p>

      <h2>19. Automated Decision-Making</h2>

      <p>
        We may use automated systems (such as spam filters or fraud
        detection tools) to review account activity and content. These
        systems assist in enforcing our Terms but do not make final legal
        or financial decisions about you without the ability for human
        review upon request.
      </p>

      <h2>20. Changes to This Policy</h2>

      <p>
        We may update this Privacy Policy from time to time to reflect
        changes in our practices, technology, legal requirements, or other
        factors. Material changes will be indicated by updating the "Last
        Updated" date at the top of this page. Continued use of the
        platform after changes constitutes acceptance of the updated
        policy.
      </p>

      <h2>21. Contact Us</h2>

      <p>
        If you have any questions, concerns, or requests regarding this
        Privacy Policy or how your data is handled, please contact us
        through the official contact details provided on this platform.
      </p>

    </div>
  );
}

export default Privacy;